import { render, staticRenderFns } from "./DetailedReport.vue?vue&type=template&id=32522d2d&scoped=true"
import script from "./DetailedReport.vue?vue&type=script&lang=js"
export * from "./DetailedReport.vue?vue&type=script&lang=js"
import style0 from "./DetailedReport.vue?vue&type=style&index=0&id=32522d2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32522d2d",
  null
  
)

export default component.exports